import createNotifier from './createNotifier'

const notify = createNotifier()

export default notify
